var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermanFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "de flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10460",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12413",
    d: "M25 1H1V25H25V1Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 93172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 118338",
    d: "M24.9987 13C24.9993 11.6373 24.7673 10.2846 24.3127 9H1.68569C0.771438 11.5883 0.771438 14.4117 1.68569 17H24.3137C24.7684 15.7154 24.9994 14.3627 24.9987 13Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 118339",
    d: "M12.9995 1C10.518 0.99994 8.09739 1.76924 6.07117 3.20196C4.04495 4.63468 2.51274 6.66034 1.68555 9H24.3145C23.4873 6.66018 21.9549 4.6344 19.9285 3.20167C17.9021 1.76894 15.4813 0.999733 12.9995 1Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 118340",
    d: "M24.3145 17H1.68555C2.5124 19.3402 4.04452 21.3664 6.07087 22.7995C8.09723 24.2327 10.5181 25.0022 13 25.0022C15.482 25.0022 17.9029 24.2327 19.9292 22.7995C21.9556 21.3664 23.4877 19.3402 24.3145 17Z",
    fill: "#FFE200"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2059",
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "#BCD6E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermanFlag);
export default __webpack_public_path__ + "static/media/german-flag.b1afcd8c86594db5b3782f30c557aa69.svg";
export { ForwardRef as ReactComponent };